// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type {
  CosmosDBManagementContext,
  CosmosDBManagementClientOptionalParams,
} from "./cosmosDBManagementContext.js";
export { createCosmosDBManagement } from "./cosmosDBManagementContext.js";
